import { Popup, TabPanel } from "devextreme-react";
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import BasicInformation from "../../PersonalRecord/BasicInformation";
import EmployeeTabWrapper from "./EmployeeTabWrapper";
import ProjectList from "./ProjectList";
import { employeeTabItems } from "./data";

export default function EmployeeWrapper(props) {
  const { employeeDataGridRef /*, divDataSource*/ /*,employeeTileViewRef*/ } =
    props;

  // const [currentEmployee, setCurrentEmployee] = useState(null);
  // const [employeeInfoPopupVisible, setEmployeeInfoPopupVisible] =
  //   useState(false);

  const userInfo = useSelector((state) => state.userInfo);

  // const employeeInfoPopupRef = useRef(null);

  // const onHiding = (e) => {
  //   setEmployeeInfoPopupVisible(false);
  // };

  // const itemTitleRender = (item) => {
  //   return <span>{item.name}</span>;
  // };

  // const itemRender = () => {
  //   return <ProjectList currentEmployee={currentEmployee} />;
  // };

  // const onShowing = (e) => {
  //   employeeInfoPopupRef.current.instance.repaint();
  // };

  return (
    // <Box
    //   direction="col"
    //   width={"100%"}
    //   height={"100%"}
    //   style={{ paddingLeft: "10px" }}
    // >
    //   <Item ratio={1} baseSize={500}>

    //   </Item>
    //   <Item ratio={2} baseSize={250}>
    //     {/* {currentEmployee && <Employee currentEmployee={currentEmployee} />} */}

    //   </Item>
    // </Box>
    <React.Fragment>
      <EmployeeTabWrapper
        employeeDataGridRef={employeeDataGridRef}
        // setCurrentEmployee={setCurrentEmployee}
        // setEmployeeInfoPopupVisible={setEmployeeInfoPopupVisible}
        // employeeTileViewRef={employeeTileViewRef}
      />
      {/* {currentEmployee && (
        <Popup
          id="employeeInfoPopup"
          ref={employeeInfoPopupRef}
          visible={employeeInfoPopupVisible}
          dragEnabled={false}
          hideOnOutsideClick={false}
          showCloseButton={true}
          title="PERSONAL RECORD"
          width={1500}
          height={"auto"}
          onHiding={onHiding}
          onShowing={onShowing}
        >
          <BasicInformation userInfo={currentEmployee} />
          <div className="sections">
            <TabPanel
              id="tpEmployee"
              height={"100%"}
              // height={800}
              dataSource={employeeTabItems}
              selectedIndex={0}
              loop={false}
              itemTitleRender={itemTitleRender}
              itemRender={itemRender}
            />
          </div>
        </Popup>
      )} */}
    </React.Fragment>
  );
}
